import get from 'lodash/get';
import { applicationTypes } from 'aurora-utils/constants';
import * as types from './constants';
const defaultState = {
  applicationType: applicationTypes.UPDATE_COMPANY,
  loading: false,
  error: null,
  activeStep: 0,
  application: {},
  projectDetails: {},
  applicationInitalData: {},
  documents: [],
  legalFormsOption: [],
  form: {},
  emrtsLookup: [],
  citiesLookup: [],
  allCitiesLookup: [],
  licenseSourceLookup: [],
  applicationId: null,
  isDed: false,
  formErrors: {},
};

export default function updateCompanyReducer(state = defaultState, action = {}) {
  switch (action.type) {
    case types.UPDATE_COMPANY_APPLICATION:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.INITIATE_START_UPDATE_COMPANY:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.INITIATE_UPDATE_COMPANY:
      return {
        ...state,
        loading: false,
        error: null,
        application: get(action.payload, 'application.result'),
        applicationId: get(action.payload, 'application.result.id'),
        applicationNumber: get(action.payload, 'application.result.applicationNumber'),
      };
    case types.UPDATE_COMPANY_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        application: get(action.payload, 'application.result'),
        applicationId: get(action.payload, 'applicationId'),
        documents: get(action.payload, 'documents', []),
        form: get(action.payload, 'form', {}),
        legalFormsOption: action.payload.legalFormsOption,
        emrtsLookup: action.payload.emrtsLookup,
        citiesLookup: action.payload.citiesLookup,
        allCitiesLookup: action.payload.allCitiesLookup,
        licenseSourceLookup: action.payload.licenseSourceLookup,
        isDed: action.payload.isDed,
        projectDetails: get(action.payload, 'projectDetails', {}),
        applicationType: get(action.payload, 'applicationType', ''),
      };

    case types.RESET_UPDATE_COMPANY_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case types.CHANGE_UPDATE_COMPANY_STEP:
      return {
        ...state,
        activeStep: get(action.payload, 'step'),
      };

    case types.ADD_TO_ERROR_INITITATE:
      return {
        ...state,
        error: null,
        loading: true,
      };

    case types.UPDATE_COMPANY_DATA:
      return {
        ...state,
        form: action.payload.form,
      };
    case types.UPDATE_CITY_DATA:
      return {
        ...state,
        citiesLookup: action.payload.citiesLookup,
      };
    case types.ADD_TO_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.CLEAR_UPDATE_COMPANY_APPLICATION_ERROR:
      return {
        ...state,
        error: null,
      };
    case types.FETCH_LEGAL_FORMS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.FETCH_LEGAL_FORMS_SUCCESS:
      return {
        ...state,
        loading: false,
        legalFormsOption: get(action.payload, 'legalFormsOption.result.legalFormsOption', []),
      };

    case types.UPDATE_COMPANY_CANCEL_APPLICATION:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.UPDATE_COMPANY_CANCEL_APPLICATION_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
      };
    }
    case types.UPDATE_COMPANY_CANCEL_APPLICATION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.UPDATE_COMPANY_DETAILS:
      return {
        ...state,
        form: {
          ...state.form,
          [action?.payload?.key]: action?.payload?.value,
        },
      };
    case types.UPDATE_COMPANY_FORM_ERROR:
      return {
        ...state,
        formErrors: {
          ...state.formErrors,
          [action?.payload?.key]: action?.payload.value,
        },
      };

    case types.UPDATE_COMPANY_CLEAR_FORM_ERROR:
      return {
        ...state,
        formErrors: {},
      };
    case types.ADD_COMPANY:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.ADD_COMPANY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.UPLOAD_COMPANY_DOCUMENT:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.UPLOAD_COMPANY_DOCUMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        documents: get(action.payload, 'documents', []),
      };
    case types.DELETE_COMPANY_DOCUMENT:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.DOWNLOAD_COMPANY_DOCUMENT:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.DOWNLOAD_COMPANY_DOCUMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.CHECKOUT_UPDATE_COMPANY:
      return {
        ...state,
        loading: true,
      };
    case types.CHECKOUT_UPDATE_COMPANY_SUCCESS:
      return {
        ...state,
        loading: false,
        activeStep: 0,
      };
    case types.CHECKOUT_UPDATE_COMPANY_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.UPDATE_COMPANY_TERMINATION_START:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.UPDATE_COMPANY_TERMINATION_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case types.FETCH_UPDATE_PROFILE_START:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.FETCH_UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
        form: get(action.payload, 'form', {}),
        legalFormsOption: action.payload.legalFormsOption,
        emrtsLookup: action.payload.emrtsLookup,
        citiesLookup: action.payload.citiesLookup,
        licenseSourceLookup: action.payload.licenseSourceLookup,
      };
    case types.SAVE_LATEST_PROFILE_START:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.SAVE_LATEST_PROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
}
